import axios, { type AxiosError } from "axios";
import { hr } from "@/constants/strings.hr";

export const API_ROOT = `${process.env.API_URL || ""}/api`;

const api = axios.create({
  baseURL: API_ROOT,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

let onUnauthorized: (() => void) | null = null;

export function setOnUnauthorized(cb: () => void) {
  onUnauthorized = cb;
}

api.interceptors.response.use(
  (res) => res,
  (err: AxiosError) => {
    if (err.response?.status === 401 && !err.config?.url?.includes("/auth/")) {
      onUnauthorized?.();
    }
    return Promise.reject(err);
  },
);

export function extractErrorMessage(err: unknown): string {
  if (axios.isAxiosError(err)) {
    const data = err.response?.data as
      { message?: string | string[] } | undefined;
    if (data?.message) {
      return Array.isArray(data.message)
        ? data.message.join(", ")
        : data.message;
    }
    if (err.code === "ERR_NETWORK") {
      return hr.errors.network;
    }
    if (err.message) return err.message;
  }
  if (err instanceof Error && err.message) return err.message;
  return hr.errors.generic;
}

export default api;
